import { Config, fetchTrailways } from '@/utils/fetch';

export const checkBooking = async (key: string) => {
    const config: Config = {
        method: 'GET',
        next: { revalidate: 0 },
        path: `booking-status/${key}`
    };
    return await fetchTrailways(config);
};

export const deleteBookingInfoKey = async (key: string) => {
    const config: Config = {
        method: 'DELETE',
        next: { revalidate: 0 },
        path: `booking-status/${key}`
    };
    return await fetchTrailways(config);
};
